import styled from 'styled-components';
import BaseClampLines from 'react-clamp-lines';

import {
  Table as SemanticTable,
  Popup,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Table = styled(SemanticTable)`
  &.ui.table {
    table-layout: fixed;
    width: 100%;
  }
`;

const Header = styled(SemanticTable.Header)``;

const Row = styled(SemanticTable.Row)``;

const HeaderCell = styled(SemanticTable.HeaderCell)``;

const Body = styled(SemanticTable.Body)``;

const Cell = styled(SemanticTable.Cell)`
  &&& {
    width: 20%;
  }
`;

const HeaderText = styled(TextLayoutComponent.Bold)``;

const CellText = styled(TextLayoutComponent)``;

const ToolTip = styled(Popup)``;

const Icon = styled(SemanticIcon)`
  &&& {
    margin-left: 5px;
  };
`;

const ContainerRating = styled.div`
  width: 400px;
`;

const ContainerHideTester = styled.div`
  width: 90px;
`;

const TextHideTester = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.deleteLink};
  cursor: pointer;
`;

const ContainerFeedback = styled.div`
  padding-top: 10px;
`;

const ContainerId = styled.div`
  width: 225px;
  overflow: hidden;
  white-space: nowrap;
`;

const LinkButton = styled.a`
  display: block;
`;

const ContainerPayment = styled.div`
  width: 225px;
`;

const ClampLines = styled(BaseClampLines)`
  .clamp-lines__button {
    border: none;
    background-color: transparent;
    color: #477AE9;
    padding: 0;
    margin: 0;
  }

`;

const RedirectToVideoLink = styled(TextLayoutComponent)`
  cursor: pointer;
  color: ${(props) => props.theme.color.primary};
  width: 190px;
`;

export {
  Table,
  Header,
  Row,
  HeaderCell,
  Body,
  Cell,
  HeaderText,
  CellText,
  ToolTip,
  Icon,
  ContainerRating,
  TextHideTester,
  ContainerHideTester,
  LinkButton,
  ContainerFeedback,
  ContainerId,
  ContainerPayment,
  ClampLines,
  RedirectToVideoLink,
};
